export function applyWithdrawUsdtFee (baseUsdt, feeUsdt) {
  const base = Number(baseUsdt)
  const fee = Number(feeUsdt)
  if (!Number.isFinite(base) || base <= 0) return null
  if (!Number.isFinite(fee) || fee <= 0) return base
  return Math.max(0, base - fee)
}
